import React from 'react';
import DraftAssignmentModelV1 from 'src/resources/GeneratedModels/DraftAssignment/DraftAssignmentModel.v1';
import {invalidatePartialInterest} from 'resources/mandark.resource';
import {Modal, addToast, Dialogue, Button} from '@albert-io/atomic';
import {resource} from '@albert-io/json-api-framework/request/builder';
import notifier from '@albert-io/notifier';

interface DeleteDraftModalProps {
  draft: DraftAssignmentModelV1;
  handleClose: () => void;
}

const DeleteDraftModal = ({draft, handleClose}: DeleteDraftModalProps) => {
  const handleDeleteFolder = () => {
    draft
      .delete()
      .then(() => {
        addToast({
          message: 'Your draft was successfully deleted',
          title: 'Success!',
          type: 'success'
        });
        invalidatePartialInterest(
          resource('draft_assignments_v1').mandarkEndpoint(['draft_assignments_v1']).done()
        );
      })
      .catch((e) => {
        notifier.notify(e, {
          component: 'Drafts',
          name: 'Drafts: failed to delete draft'
        });
        addToast({
          message:
            'An error was encountered while trying to delete your draft. Please try again. If the problem persists, contact us.',
          title: 'Something went wrong',
          type: 'danger'
        });
      });
    handleClose();
  };

  return (
    <Modal ariaLabel='Delete Folder Modal' handleClose={handleClose}>
      {({CloseButtonWrapper, modalContentStyle}) => {
        return (
          <Dialogue
            size='m'
            inModal
            handleClose={handleClose}
            title='Delete draft'
            className={modalContentStyle}
          >
            <Dialogue.Body>Are you sure you want to delete your draft?</Dialogue.Body>
            <Dialogue.BtnGroup>
              <CloseButtonWrapper>
                <Button variant='text'>Cancel</Button>
              </CloseButtonWrapper>
              <Button color='destructive' onClick={handleDeleteFolder}>
                Delete
              </Button>
            </Dialogue.BtnGroup>
          </Dialogue>
        );
      }}
    </Modal>
  );
};

export default DeleteDraftModal;
